<template>
  <section class="donation-thank-section">
    <container>
      <div class="col-12 col-sm-4 col-lg-5">
        <h2 class="thank-you-left">ขอบคุณฮีโร่ทุกตัว</h2>
      </div>
      <div class="col-12 col-sm-4 col-lg-2">
        <img src="@/assets/donation-info/donation-thank-you.png" alt="blood donation thank you">
      </div>
      <div class="col-12 col-sm-4 col-lg-5">
        <h2 class="thank-you-right">ที่มีส่วนช่วยต่อชีวิต</h2>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'DonationThankYouSection',
  components: {
    Container
  }
}
</script>

<style scoped lang="scss">
.donation-thank-section {
  background-color: $gray-100;
  padding: 3rem 0;
  h2 {
    text-align: center;
    font-size: $h3-font-size;
    color: $primary;
  }
  img {
    width: 10rem;
    margin: auto;
    display: block;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .donation-thank-section {
    h2 {
      font-size: $h3-font-size;
      margin-top: 2rem;
      &.thank-you-left {
        text-align: right;
      }
      &.thank-you-right {
        text-align: left;
      }
    }
    img {
      width: 100%;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "md")) {
  .donation-thank-section {
    h2 {
      font-size: $h2-font-size;
      margin-top: 3rem;
    }
  }
}
</style>
